var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',[_c('div',{staticClass:"measure-wrapper"},[_c('div',{staticClass:"measure-instructions"},[_vm._v(_vm._s(_vm.instructions))])]),_c('div',{staticClass:"measure-label"},[_vm._v("DISCLAIMER: Measurements are approximate")])])}
var staticRenderFns = []

export { render, staticRenderFns }